import './app.css';
import '@babel/polyfill';
import './js/fonts';
import './js/share';
import './js/img-tiny';
import ieFix from './js/ie-fix';

import NanoEvents from 'nanoevents';
import Hammer from 'hammerjs';

import intro from './js/intro';
import lottery from './js/lottery';
import animations from './js/animations';
import analyticsEvent from './js/analyticsEvent';
import debounce from 'debounce';
import {TweenMax} from 'gsap';


window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;
import lazysizes from 'lazysizes';
let lazysizesFlag = false;


const isMobile = require('ismobilejs');
const addWheelListener = require('wheel').addWheelListener;


ieFix.init();

{
    const introvideo = document.getElementById('myVideo');
    let playButtonSet = false;
    
    const setVideoButton = () => {
        const playButton = document.querySelector('[data-video-play]');
        if (playButton) {
            playButton.addEventListener('click', playVideo);
            playButtonSet = true;
        }
    };

    const playVideo = () => {
        if (introvideo && typeof introvideo.play === 'function') {
            const promise = introvideo.play();
            
            if (typeof promise !== 'undefined') {
                promise.then(() => {
    
                }).catch(() => {
                    // playVideo();
                    if (!playButtonSet) {
                        setVideoButton();
                    }
                });
            }
        }
    };

    playVideo();
}


{
    setTimeout(() => {
        require('./js/audio');
    }, 100);
}

{
    if (isMobile.android.device) {
        document.body.dataset.android = 'true';
    }

    if (isMobile.apple.device) {
        document.body.dataset.apple = 'true';
    }
}

{
    const init = () => {
        intro.init(document);
        lottery.init(document);
        
        animations.intro();
    }
    
    // window.addEventListener('load', init);

    setTimeout(() => {
        init();
    }, 10);
}


{
    const trackingElements = [...document.querySelectorAll('[data-event][data-event-category][data-event-label]')];

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
                analyticsEvent(
                    trackingElem.getAttribute('data-event-category'),
                    trackingElem.getAttribute('data-event'),
                    trackingElem.getAttribute('data-event-label')
                );
            });
        });
    }
}


// game parallax
// {
//     let introRellaxDestroy;
//     const slide = document.getElementById('viewport-slide-2');
    
//     const introRellax = () => {
//         if (typeof introRellaxDestroy === 'function') {
//             introRellaxDestroy();
//         }  

//         console.log(77777);
    
//         introRellaxDestroy = rellaxStuff.init(slide, '.rellax', true);
//     };
    
//     window.addEventListener('resize', introRellax);
//     introRellax();
// }




// scroll

{
    let lastY;
    const emmiter = new NanoEvents();

    const detectMouseWheelDirection = event => {
        let delta = null,
            direction = false;
    
        if (!event) {
            event = window.event;
        }
    
        if (event.wheelDelta) {
            delta = event.wheelDelta / 60;
        } else if (event.detail) {
            delta = -event.detail / 2;
        } else if (event.deltaY) {
            delta = -event.deltaY / 20;
        } else if (event.originalEvent && event.originalEvent.wheelDelta) {
            delta = event.originalEvent.wheelDelta / 60;
        }
    

        if (delta !== null) {
            direction = delta > 0 ? 'up' : 'down';
        }

    
        if (!direction && event.originalEvent && event.originalEvent.touches) {
            const currentY = event.originalEvent.touches[0].clientY;
            direction = currentY > lastY ? 'down' : 'up';
            lastY = currentY;
        }
    
        return direction;
    };
    
    const detectSlideEdge = slide => {
        const result = [];
        const isStart = slide.scrollTop === 0;
        const isEnd = Math.abs(slide.scrollTop - (slide.scrollHeight - slide.offsetHeight)) < 3;
    
        if (isStart) {
            result.push('start');
        }
    
        if (isEnd) {
            result.push('end');
        }
    
        if (!isStart && !isEnd) {
            result.push('middle');
        }

        return result;
    };
    
    const moveSlideUp = slide => {
        slide.style.transform = 'translate3d(0, -100%, 0)';
        const index = viewportSlides.findIndex(el => el === slide) + 1;
        emmiter.emit('slide', {
            direction: 'up',
            index
        });

        activeSlide = viewportSlides[index];
    };
    
    
    const moveSlideDown = slide => {
        slide.style.transform = 'translate3d(0, 0, 0)';
        const index = viewportSlides.findIndex(el => el === slide);
        emmiter.emit('slide', {
            direction: 'down',
            index
        });
 
        activeSlide = viewportSlides[index];
    };
    
    const viewport = document.getElementById('viewport');
    const viewportSlides = [...viewport.querySelectorAll('.viewport__slide')];
    const lastSlide = viewportSlides[viewportSlides.length - 1];
    const firstSlide = viewportSlides[0];
    let activeSlide = firstSlide;
    
    
    
    viewportSlides.forEach((slide, index) => {
        const slideMove = direction => {
            const edge = detectSlideEdge(slide);

            if (slide !== lastSlide && direction === 'down' && edge.indexOf('end') !== -1) {
                moveSlideUp(slide);
            }
            
            if (slide !== firstSlide && direction === 'up' && edge.indexOf('start') !== -1) {
                moveSlideDown(viewportSlides[index - 1]);
            }
        };

        const debouncecSlideMove = debounce(slideMove, 50, true);


        const slideWheel = event => {
            const direction = detectMouseWheelDirection(event);
            debouncecSlideMove(direction);
        };

        const slideLinks = [...document.querySelectorAll('[data-slide-move]')];
        slideLinks.forEach(link => {
            link.addEventListener('click', () => {
                const direction = link.dataset.slideMove;
                if (direction) {
                    slideMove(direction);
                }
            });
        });
    
        slide.style.zIndex = viewportSlides.length - index;
        slide.style.transition = 'transform 0.7s ease-in-out';
        slide.style.transform = 'translate3d(0, 0, 0)';
        
        addWheelListener(slide, slideWheel);
        const hammertime = new Hammer(slide);
    
        hammertime.on('panup', () => {
            slideMove('down');
        });
    
        hammertime.on('pandown', () => {
            slideMove('up');
        });

        document.body.addEventListener('keydown', event => {
            if (event.key === 'ArrowUp' || event.code === 'ArrowUp') {
                if (activeSlide === slide) {
                    TweenMax.to(activeSlide, 0.3, {
                        scrollTop: activeSlide.scrollTop - 60
                    });

                    slideMove('up');
                }
            }
    
            if (event.key === 'ArrowDown' || event.code === 'ArrowDown') {
                if (activeSlide === slide) {

                    TweenMax.to(activeSlide, 0.3, {
                        scrollTop: activeSlide.scrollTop + 60
                    });

                    slideMove('down');
                }
    
            }
        });
    });



    emmiter.on('slide', params => {
        analyticsEvent('Slide', 'change', 'Slide: ' + (params.index + 1) + ', Direction: ' + params.direction);

        if (!lazysizesFlag) {
            lazysizesFlag = true;
            lazysizes.init();
        }

        // if (typeof window.ga === 'function') {
            //     window.ga('set', 'page', '/slide-' + gaIndex);
            //     window.ga('send', 'pageview');
            // }
            
        const gaIndex = params.index + 1;
        const dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'Pageview',
            page: '/slide-' + gaIndex
        });
        
        if (params.direction === 'up' && params.index === 1) {
            animations.game();
        }


        const bottleMouseEnter = () => {
            animations.productHover();
        };

        const bottle = document.getElementById('bottle');

        if (params.direction === 'up' && params.index === 2) {
            animations.product();


            if (bottle) {
                setTimeout(() => {
                    bottle.addEventListener('mouseenter', bottleMouseEnter);
                }, 1000);
            }
        }
        if (params.direction === 'down' && params.index === 2) {
            if (bottle) {
                bottle.removeEventListener('mouseenter', bottleMouseEnter);
            }
        }
    })
}


// WEBPACK FOOTER //
// ./part1.js